const VERSION = "0.9.5";

export default VERSION;
